/**
 * Centralized regex patterns for filename validation and parsing
 * All patterns are case-insensitive for matching but normalized to lowercase
 * 
 * Note: While these patterns include state in filenames for visibility,
 * the source of truth for an item's state is its frontmatter. The sync command
 * ensures filename and filesystem location match the frontmatter state.
 */
export const PATTERNS = {
  /**
   * Pattern for files in state directories (_*): {uuid}-{type}-{state}.md
   * Example: abc1-bug-active.md
   * 
   * Note: State in filename should match frontmatter state.
   * The sync command ensures this consistency.
   */
  STATE_FILE: /^([a-z0-9]{4})-([a-z]+)-([a-z]+)\.md$/i,
  
  /**
   * Pattern for files in type directories:
   * - {uuid}-{type}.md
   * - {uuid}-{type}-{state}.md
   * - {uuid}-{type}-{state}-plan-{planid}.md
   * 
   * Note: State in filename should match frontmatter state.
   * The sync command ensures this consistency.
   */
  TYPE_FILE: /^([a-z0-9]{4})-([a-z]+)(?:-([a-z]+))?(?:-plan-([a-z0-9]{4}))?\.md$/i,
  
  /**
   * Pattern for archived files: {archive_alias}-{type}-{uuid}.md
   * Example: done-bug-abc1.md
   * 
   * Note: Archive state should match frontmatter and optional archive_path configuration.
   * The sync command ensures this consistency.
   */
  ARCHIVE_FILE: /^(archived|done)-([a-z]+)-([a-z0-9]{4})\.md$/i,
  
  /**
   * Pattern for files with plan references: {uuid}-{type}-{state}-plan-{planid}.md
   * Example: abc1-bug-active-plan-def2.md
   * 
   * Note: State in filename should match frontmatter state.
   * The sync command ensures this consistency.
   */
  PLAN_FILE: /^([a-z0-9]{4})-([a-z]+)-([a-z]+)-plan-([a-z0-9]{4})\.md$/i,
  
  /**
   * Pattern for simple files: {uuid}-{type}.md
   * Example: abc1-bug.md
   */
  INBOX_FILE: /^([a-z0-9]{4})-([a-z]+)\.md$/i,
  
  /**
   * Pattern for UUID validation (4 chars)
   */
  UUID: /^[a-z0-9]{4}$/i,
  
  /**
   * Pattern for type validation (lowercase letters only)
   */
  TYPE: /^[a-z]+$/,
  
  /**
   * Pattern for state validation (lowercase letters only)
   */
  STATE: /^[a-z]+$/,
  
  /**
   * Pattern for archive alias validation (lowercase letters only)
   * Currently supports: 'archived' or 'done'
   */
  ARCHIVE_ALIAS: /^(archived|done)$/,
  
  /**
   * Pattern for plan ID validation (4 chars)
   */
  PLAN_ID: /^[a-z0-9]{4}$/i
}; 